import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/expansion'

Styxie.Initializers.ExpansionOverview = {
  index: async(props) => {
    const { default: OverviewIndex } = await import('@/vue_widgets/expansion/overview/index.vue')
    createVueApp(OverviewIndex, { props, sidebar })
  }
}
